var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { statusFilterItem } from '../../types';
export var buildStatusFilterArray = function (selectedStatuses) {
    if (!selectedStatuses || selectedStatuses.length === 0)
        return undefined;
    var result = selectedStatuses.slice();
    var hasScheduled = result.includes(statusFilterItem.scheduled);
    var hasRecurringScheduled = result.includes(statusFilterItem.recurring_scheduled);
    if (hasScheduled && !hasRecurringScheduled) {
        result = __spreadArray(__spreadArray([], result, true), [statusFilterItem.recurring_scheduled], false);
    }
    return result;
};
